import React, { useState } from "react";
import { create, pay } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import { Form, Input, Button, message, Checkbox, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";

interface MovieProposalType {
  movieName: string;
  description?: string;
  pseudo: string;
  donate: boolean;
}

const MovieProposal: React.FC = () => {
  const { user } = useAuth();
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => {
    setIsModalVisible(false);
    setLoading(false);
    form.resetFields();
  };

  const handleSubmit = async (values: MovieProposalType) => {
    if (!user) return;
    setLoading(true);
    try {
        const movie = await create("movies", {
          name: values.movieName,
          description: values.description,
          pseudo: values.pseudo,
          status: "pending",
          amount: 0,
        });
        await pay(movie.id, user.uid, values.donate);
      } catch (err) {
      message.error("Une erreur est survenue, veuillez réessayer.");
    }
    setLoading(false);
  };

  return (
    <div>
      {user && <Button ghost onClick={handleOpenModal}>
        Proposer un film
      </Button>}

      <Modal
        title="Proposer un film"
        open={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
        width={Math.min(window.innerWidth - 32, 800)}
        centered
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            movieName: "",
            donate: false,
          }}
        >
          <Form.Item
            label="Nom du film"
            name="movieName"
            rules={[
              { required: true, message: "Titre du film requis!" },
            ]}
          >
            <Input placeholder="Entrez le titre du film" />
          </Form.Item>

          <Form.Item
            label="Description"
            name="description"
            rules={[
              { required: true, message: "Description du film requise!" },
            ]}
          >
            <TextArea autoSize={{ minRows: 3 }} maxLength={150} placeholder="Décrivez le film pour les autres participants" />
          </Form.Item>

          <Form.Item
            label="Votre pseudo"
            name="pseudo"
            rules={[
              { required: true, message: "Pseudo requis!" },
            ]}
          >
            <Input placeholder="Entrez votre pseudo" />
          </Form.Item>

          <Form.Item name="donate" valuePropName="checked">
            <Checkbox>
              Je souhaite que ma participation soit reversée dans la cagnotte si l'objectif de financement n'est pas atteint
            </Checkbox>
          </Form.Item>

            <Button loading={loading} type="primary" htmlType="submit">
              Financer
            </Button>
        </Form>
      </Modal>
    </div>
  );
};

export default MovieProposal;
